/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormTextBox from "../../../shared/forms/FormFields/FormTextBox";
import FormInputNumber from "../../../shared/forms/FormFields/FormInputNumber";
import FormDropDown from "../../../shared/forms/FormFields/FormDropDown";
import FormClipboardImage from "../../../shared/forms/FormFields/FormClipboardImage";
import useApiIncidencia from "../../../api/administracion/useApiIncidencia";
import useForm from "../../../shared/forms/useForm";
import { Dialog } from "primereact/dialog";
import { useEffect } from "react";
import { Button } from "primereact/button";
import { serialize } from "object-to-formdata";
import FormCheckBox from "../../../shared/forms/FormFields/FormCheckBox";
import ExGrid from "../../../shared/Grid/ExGrid";
import ExColumn from "../../../shared/Grid/ExColumn";
import AddButton from "../../../shared/Grid/Buttons/AddButton";
const initialValues = {};

const Cargos = ({ incidenciaId, visible, onClose, onSaved }) => {
    const api = useApiIncidencia();
    const [submitted, setSubmitted] = useState(false);
    const {
        values: cargo,
        setValues,
        onChange,
        onValidate,
        isValid
    } = useForm(initialValues);

    useEffect(() => {
        setValues(initialValues);
    }, [visible]);

    const onSave = async () => {
        setSubmitted(true);
        console.log('guardar')
        if (!isValid)
            return;

        const formData = serialize(cargo ?? {}, { indices: true, dotsForObjectNotation: true });
        await api.agregarCargo(incidenciaId, formData);
        onSaved();
    };

    const renderFooterModal = () => {
        return (
            <div className="p-1">
                <Button label="Cancelar" onClick={onClose} className="p-button-outlined" />
                <Button label="Guardar" onClick={onSave} type="button" />
            </div>
        );
    }

    return (
        <Dialog header="Nuevas Incidencias" visible={visible} style={{ width: '50%' }}
            onHide={onClose} footer={renderFooterModal}>
            <Form columns={2} values={cargo} onChange={onChange} onValidate={onValidate}
                submitted={submitted}>
            <Field field={"cargo"} cols={6} 
                render={({ value, onParentChange, ...props }) => (
                    <ExGrid 
                        {...props} 
                        data={value}
                        onChange={(data) => onParentChange({ cargo: data })}
                        getEntityId={(row) => row._uniqueUid}
                    >
                        <ExColumn 
                            field="departamentoId" 
                            title="Departamento" 
                            source="departamentos"
                            required={true}
                            cellRenderer={({ row, ...props }) => 
                                <FormDropDown disabled={false} style={{ width: '100%' }} {...props} />
                            }
                        />
                        <ExColumn 
                            field="concepto" 
                            title="Concepto" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormTextBox disabled={false} style={{ width: '100%' }} {...props} />
                            }
                        />
                           <ExColumn 
                            field="costo" 
                            title="Costo" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormInputNumber disabled={false} mode="decimal" maxFractionDigits={2}  style={{ width: '100%' }} {...props} />
                            }
                        />
                        <ExColumn 
                            field="evidencia" 
                            title="Evidencia" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormClipboardImage disabled={false} style={{ width: '100%' }} {...props} />
                            }
                        />
                        <ExColumn 
                            field="cobro" 
                            title="Cobro" 
                            required={true} 
                            cellRenderer={({ row, ...props }) => 
                                <FormCheckBox disabled={false} style={{ width: '100%' }} {...props} />
                            }
                        />
                        <ExColumn 
                            field={"command"}
                            headerRenderer={({ onAdd }) => <AddButton onAdd={onAdd} />}
                            
                            width={'50px'} 
                        />
                    </ExGrid>
                )}
            />
            </Form>
        </Dialog>
    );
};

export default Cargos;
